import { OhsCusval } from 'global-components/form/cusvals/OhsCusvalModel';

export const fullCusvalConfig1: OhsCusval[] = [
  {
    title: 'Cus Telephone',
    description: null,
    type: 'tel',
    required: false,
    _id: 'cus-1-tel',
  },
  {
    title: 'Cus Number',
    description: null,
    type: 'number',
    required: false,
    _id: 'cus-1-number',
  },
  {
    title: 'Cus Time',
    description: null,
    type: 'time',
    required: true,
    _id: 'cus-1-time',
  },
  {
    title: 'Cus Color',
    description: null,
    type: 'color',
    required: true,
    _id: 'cus-1-color',
  },
  {
    title: 'Cus URL',
    description: null,
    type: 'url',
    required: false,
    _id: 'cus-1-url',
  },
  {
    title: 'Cus Currency',
    description: null,
    type: 'currency',
    required: true,
    options: ['AUD', 'PHP'],
    _id: 'cus-1-currency',
  },
  {
    title: 'Cus Radio',
    description: null,
    type: 'radio',
    required: true,
    options: [
      {
        name: 'Opt 1',
      },
      {
        name: 'Opt 2',
      },
    ],
    _id: 'cus-1-radio',
  },
  {
    title: 'Cus Checkbox',
    description: null,
    type: 'checkbox',
    required: true,
    options: [
      {
        name: 'Check 1',
      },
      {
        name: 'Check 2',
      },
      {
        name: 'Check 3',
      },
    ],
    _id: 'cus-1-checkbox',
  },
  {
    title: 'Cus Single Select',
    description: null,
    type: 'select_single',
    required: true,
    options: [
      {
        name: 'Select 1',
      },
      {
        name: 'Select 2',
        options: [
          {
            name: 'Select 2 - a',
          },
          {
            icon: 'low vision',
            name: 'Select 2 - b',
          },
          {
            name: 'Select 2 - c',
            options: [
              {
                icon: 'adjust',
                name: 'Select 2 - c - 1',
              },
              {
                name: 'Select 2 - c - 2',
              },
              {
                icon: 'archive',
                name: 'Select 2 - c - 3',
              },
            ],
          },
        ],
      },
    ],
    _id: 'cus-1-select',
  },
  {
    title: 'Cus Multi Select',
    description: null,
    type: 'select_multiple',
    required: true,
    options: [
      {
        name: 'Multi Opt 1',
      },
      {
        name: 'Multi Opt 2',
      },
      {
        name: 'Multi Opt 3',
        options: [
          {
            icon: 'arrow alternate circle down',
            name: 'Multi opt 3 - a',
          },
          {
            icon: 'hand lizard',
            name: 'Multi opt 3 - b',
          },
          {
            icon: 'address book',
            name: 'Multi opt 3 - c',
            options: [
              {
                name: 'Multi opt 3 - c - 1',
              },
              {
                name: 'Multi opt 3 - c - 2',
              },
              {
                icon: 'arrow circle down',
                name: 'Multi opt 3 - c - 3',
              },
            ],
          },
        ],
      },
    ],
    _id: 'cus-1-select-multiple',
  },
  {
    title: 'Test Field',
    description: null,
    type: 'text',
    required: false,
    _id: 'cus-1-text',
  },
  {
    title: 'Static Header Test',
    description: 'aasdasdasdasdasd',
    type: 'static',
    required: false,
    options: [],
    _id: 'cus-1-static',
  },
  {
    title: 'cus email',
    description: null,
    type: 'email',
    required: false,
    _id: 'cus-1-email',
  },
  {
    title: 'cus date',
    description: null,
    type: 'date',
    required: false,
    _id: 'cus-1-date',
  },
] as OhsCusval[];

export const fullCusvalConfig2: OhsCusval[] = [
  {
    title: 'Cus multi',
    description: null,
    type: 'select_multiple',
    required: true,
    options: [
      {
        name: 'AA',
      },
      {
        name: 'bb',
      },
      {
        name: 'CC',
      },
    ],
    _id: 'cus-2-select-multiple',
  },
  {
    title: 'Cus Date',
    description: null,
    type: 'date',
    required: false,
    _id: 'cus-2-date',
  },
  {
    title: 'Samp Rad',
    description: null,
    type: 'radio',
    required: false,
    options: [
      {
        name: 'test a',
      },
      {
        name: 'test b',
      },
    ],
    _id: 'cus-2-rad',
  },
  {
    title: 'Multi  layered',
    description: 'aa',
    type: 'select_multiple',
    required: false,
    options: [
      {
        name: 'A Level 1',
      },
      {
        name: 'B Level 1',
        options: [
          {
            name: 'B Level 2',
          },
          {
            name: 'BB Level 2',
          },
        ],
      },
      {
        name: 'C Level 1',
        options: [
          {
            name: 'C Level 2',
          },
          {
            name: 'CC Level 2',
            options: [
              {
                name: 'C Level 3',
              },
              {
                name: 'CC Level 3',
              },
            ],
          },
        ],
      },
      {
        name: 'D Level 1',
        options: [
          {
            name: 'D Level 2',
            options: [
              {
                name: 'D Level 3',
                options: [
                  {
                    name: 'D Level 4',
                  },
                  {
                    name: 'DD Level 4',
                  },
                ],
              },
              {
                name: 'DD Level 3',
              },
            ],
          },
          {
            name: 'DD Level 2',
          },
        ],
      },
    ],
    _id: 'cus-2-select-multiple-2',
  },
] as OhsCusval[];

export const fullCusvalValue1 = [
  {
    _id: 'cus-1-color',
    value: '#000000',
    type: 'color',
    title: 'Cus Color',
  },
  {
    _id: 'cus-1-url',
    value: 'https://asd.com',
    type: 'url',
    title: 'Cus URL',
  },
  {
    _id: 'cus-1-currency',
    value: {
      code: 'AUD',
      amount: '123',
    },
    type: 'currency',
    title: 'Cus Currency',
  },
  {
    _id: 'cus-1-radio',
    value: ['Opt 1'],
    type: 'radio',
    title: 'Cus Radio',
  },
  {
    _id: 'cus-1-checkbox',
    value: ['Check 1'],
    type: 'checkbox',
    title: 'Cus Checkbox',
  },
  {
    _id: 'cus-1-select',
    value: ['Select 1'],
    type: 'select_single',
    title: 'Cus Single Select',
  },
  {
    _id: 'cus-1-select-multiple',
    value: ['Multi Opt 1'],
    type: 'select_multiple',
    title: 'Cus Multi Select',
  },
  {
    _id: 'cus-1-tel',
    value: '297 - 123',
    type: 'tel',
    title: 'Cus Telephone',
  },
  {
    _id: 'cus-1-time',
    value: {
      hours: 23,
      minutes: 12,
    },
    type: 'time',
    title: 'Cus Time',
  },
];

export const fullCusvalValueInvalid1 = [
  // Invalid cusvals
  {
    _id: 'invalid-cus-1-color',
    value: '#000000',
    type: 'color',
    title: 'Old Cus Color',
  },
  {
    _id: 'invalid-cus-1-url',
    value: 'https://asd.com',
    type: 'url',
    title: 'Old Cus URL',
  },
  {
    _id: 'invalid-cus-1-currency',
    value: {
      code: 'AUD',
      amount: '123',
    },
    type: 'currency',
    title: 'Old Cus Currency',
  },
  {
    _id: 'invalid-cus-1-radio',
    value: ['Opt 1'],
    type: 'radio',
    title: 'Old Cus Radio',
  },
  {
    _id: 'invalid-cus-1-checkbox',
    value: ['Check 1'],
    type: 'checkbox',
    title: 'Old Cus Checkbox',
  },
  {
    _id: 'invalid-cus-1-select',
    value: ['Select 1'],
    type: 'select_single',
    title: 'Old Cus Single Select',
  },
  {
    _id: 'invalid-cus-1-select-multiple',
    value: ['Multi Opt 1'],
    type: 'select_multiple',
    title: 'Old Cus Multi Select',
  },
  {
    _id: 'invalid-cus-1-tel',
    value: '297 - 123',
    type: 'tel',
    title: 'Old Cus Telephone',
  },
  {
    _id: 'invalid-cus-1-time',
    value: {
      hours: 23,
      minutes: 12,
    },
    type: 'time',
    title: 'Old Cus Time',
  },
  // Valid cusvals
  {
    _id: 'cus-1-color',
    value: '#000000',
    type: 'color',
    title: 'Cus Color',
  },
  {
    _id: 'cus-1-url',
    value: 'https://asd.com',
    type: 'url',
    title: 'Cus URL',
  },
  {
    _id: 'cus-1-currency',
    value: {
      code: 'AUD',
      amount: '123',
    },
    type: 'currency',
    title: 'Cus Currency',
  },
  {
    _id: 'cus-1-radio',
    value: ['Opt 1'],
    type: 'radio',
    title: 'Cus Radio',
  },
  {
    _id: 'cus-1-checkbox',
    value: ['Check 1'],
    type: 'checkbox',
    title: 'Cus Checkbox',
  },
  {
    _id: 'cus-1-select',
    value: ['Select 1'],
    type: 'select_single',
    title: 'Cus Single Select',
  },
  {
    _id: 'cus-1-select-multiple',
    value: ['Multi Opt 1'],
    type: 'select_multiple',
    title: 'Cus Multi Select',
  },
  {
    _id: 'cus-1-tel',
    value: '297 - 123',
    type: 'tel',
    title: 'Cus Telephone',
  },
  {
    _id: 'cus-1-time',
    value: {
      hours: 23,
      minutes: 12,
    },
    type: 'time',
    title: 'Cus Time',
  },
];
